<template>
<v-card elevation='0'>
  <v-card-title>Permissions</v-card-title>
  <v-card-text>
    <div class="form-group field-conference-user_id">
      <label class="control-label" for="conference-user_id">Conference Owner</label>
      <select id="conference-user_id" class="form-control" v-model="conf.user_id" v-on:change="changeOwner()" style="appearance: menulist;">
        <option v-for="user in users" v-bind:value="user.user_id" v-bind:key="user.user_id">{{user.first_name}}&nbsp;{{user.last_name}}&nbsp;({{user.username}})</option>
      </select>
    </div>

    <div class="form-group field-share_with_account">
      <label class="control-label" for="conference-user_id">Access</label>
      <select id="conference-share_with_account" class="form-control" v-model="conf.share_with_account" v-on:change="changeAccountAccess()" style="appearance: menulist;">
        <option value="Y">All users</option>
        <option value="N">Only selected users</option>
      </select>
    </div>

    <div v-if="conf.share_with_account=='N'">
      <b>Allowed</b>
      <div id="yes-people" v-if="conf.users.length>0">
        <table class="kv-grid-table table table-bordered table-striped kv-table-wrap">
          <thead>
            <tr>
              <th style="width:80%">
                User
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in conf.users" v-bind:key="user.user_id">
              <td>
                <v-row class='px-2'>
                  {{user['first_name']}}&nbsp;{{user['last_name']}} ({{user['username']}})
                  <v-spacer></v-spacer>
                  <v-btn small icon color='red' v-on:click="removeUserFromConference(user,conf.conference_id)">
                    <v-icon color='red'>mdi-close-circle</v-icon>
                  </v-btn>
                </v-row>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div v-if="conf.users.length==0">
        <p>None. Only the conference owner will see the conference in the mobile app.</p>
      </div>


      <br>
      <b>Not Allowed</b>
      <div id="no-people">
        <table class="kv-grid-table table table-bordered table-striped kv-table-wrap">
          <thead>
            <tr>
              <th style="width:80%">
                User
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in notPermissionedUsers" v-bind:key="user.user_id">
              <td>
                <v-row class='px-2'>
                  {{user['first_name']}}&nbsp;{{user['last_name']}} ({{user['username']}})
                  <v-spacer></v-spacer>
                  <v-btn small icon color='primary' v-on:click="addUserToConference(user,conf.conference_id,'Y')">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-row>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="alert alert-warning">
          <strong>Note:</strong> The permissions above affect visibility in the mobile app. Anyone with the correct PIN can still access the conference.
      </div>
    </div>
  </v-card-text>
</v-card>
</template>

<script >

const ownerAccessMutation = `
  mutation conferenceOwnerAccess($conferenceId: Int!, $ownerUserId: Int!, $shareWithAccount: String!) {
    setConferenceOwnerAndAccessType(conferenceId:$conferenceId, ownerUserId:$ownerUserId, shareWithAccount:$shareWithAccount) {
      conference_id
      name
      user_id
      share_with_account
      pins {
          pin
          is_admin
          is_active
      }
      users {
          user_id
          first_name
          last_name
          user_id
          username
      }
    }
  }
`;

const userConferenceMutation = `
  mutation conferenceUserAdd($userId: Int!, $conferenceId: Int!, $isAdmin: String!) {
    addUserToConference(userId:$userId, conferenceId:$conferenceId, isAdmin:$isAdmin) {
      conference_id
      name
      user_id
      share_with_account
      pins {
          pin
          is_admin
          is_active
      }
      users {
          user_id
          first_name
          last_name
          user_id
          username
      }
    }
  }
`;

const removeUserConferenceMutation = `
  mutation conferenceUserRemove($userId: Int!, $conferenceId: Int!) {
    removeUserFromConference(userId:$userId, conferenceId:$conferenceId) {
      conference_id
      name
      user_id
      share_with_account
      pins {
          pin
          is_admin
          is_active
      }
      users {
          user_id
          first_name
          last_name
          user_id
          username
      }
    }
  }
`;

import ConferenceCommon from '../mixins/conferencecommon';
import Common from '../mixins/common';
import Vue from 'vue';

export default {
  data: function() {
    return {
      
    }
  },
  props: {},
  mixins: [Common, ConferenceCommon],
  computed: {
    notPermissionedUsers() {
      let pusers = this.conf.users;
      let ret = [];
      for (let i=0;i<this.users.length;i++) {
        let u = this.users[i];
        let u2 = pusers.find(x => x.user_id === u.user_id);
        if (!u2) {
          ret.push(u);
        }
      }
      return ret;
    },
    users: {
      get: function() {
        return this.$store.state.users;
      },
    }
  },
  methods: {
    changeOwner() {
      let self = this;
      let variables = {
        conferenceId: parseInt(this.conf.conference_id),
        ownerUserId: parseInt(this.conf.user_id),
        shareWithAccount: this.conf.share_with_account,
      }
      global.gqlClient().request(ownerAccessMutation, variables).then(function(result) {});
    },
    changeAccountAccess() { 
      this.changeOwner();
    },
    addUserToConference(user, conferenceId, isAdmin) {
      let self = this;
      //console.log('adding ' + user.first_name + ' to ' + conferenceId);
      let variables = {
        conferenceId: parseInt(conferenceId),
        userId: parseInt(user.user_id),
        isAdmin: isAdmin,
      }
      //console.log(variables);
      global.gqlClient().request(userConferenceMutation, variables).then(function(result) {
        //console.log(result);
        let c = result.addUserToConference;
        console.log(c);
        Vue.set(self.conf,'users',c.users);
      });
    },
    removeUserFromConference(user, conferenceId) {
      let self = this;
      //console.log('removing ' + user.first_name + ' to ' + conferenceId);
      let variables = {
        conferenceId: parseInt(conferenceId),
        userId: parseInt(user.user_id)          }
      //console.log(variables);
      global.gqlClient().request(removeUserConferenceMutation, variables).then(function(result) {
        let c = result.removeUserFromConference;
        //console.log(c.name);
        self.conf.users = c.users;
        
      });
    },
  },
  async mounted() {
    
  }
}
</script>
